export const INVESTMENT_QUESTIONS = [
  "What is the strategy of the fund?",
  "What investment scope does the fund have - any investment restrictions?",
  "What legal form is the fund?",
  "Are there any limitations on the risks the fund can take? Diversification? If yes, how does the fund report this?",
  "How often does the fund report NAV? Is the NAV audited?",
  "What does the fund report more than NAV? What granulariuty?",
  "Is there any key person clause? If yes, who are the key persons? If any of the key persons leave - can this be cured? What happens if it is not cured?",
  "Can the shareholders remove the managers of the fund without cause? Under what circumstances can the shareholders remove the manager?",
  "Does the manager commit to invest in the fund? If yes, how much? Could this investment be made in kind or offset vs fees?",
  "Does the manager have an allocation policy - if yes how does the manger make sure that this is followed - what measures are put in place?",
  "Does the fund have a performance fee? If yes, summarize the waterfall. Is there any clawback on the performance fee?",
  "Are there any limitations on the fund manager to launch other funds with the same or other strategies?",
  "How is the management fee calculated? Do investors pay fees on net cash in the fund?",
  "Do shareholders have preferred rights to co-investments?",
  "Are shareholders free to transfer or sell their shares?",
];

export const BOND_QUESTIONS = [
  "What is the issuer's full legal name and registration number?",
  "In which jurisdiction is the issuer incorporated?",
  "Is the issuer a holding company or an operating entity?",
  "Are there any guarantors?",			
  "In which jurisdictions are the guarantors incorporated?",
  "Are the guarantees joint and several?",		
  "What law governs the bonds (e.g., New York, English, Luxembourg)?",
  "What is the governing law of the guarantees?",	
  "What are the dispute resolution and jurisdiction clauses?",
  "Are there arbitration provisions or local court designations?",
  "Who acts as trustee or paying agent?",		
  "What are the trustee's powers and enforcement rights?",
  "What are the trustee's indemnification and replacement clauses?",
  "What clearing systems are used (Euroclear, Clearstream, DTC)?",
  "What is the form of the notes (global, registered, bearer)?",
  "What is the denomination per note?",		
  "Has the prospectus been approved by a competent authority (CSSF, FCA, etc.)?",
  "What is the ISIN / Common Code / CUSIP assigned?",	
  "Is the issuance listed? If so, on which exchange or MTF?",
  "Are there any restrictions under US Rule 144A or Regulation S?",
  // 2. Key Economic Terms
  "What is the total issue size?",
  "What is the issue price (% of par)?",
  "What is the coupon rate (fixed, floating, step-up, or PIK)?",
  "What is the coupon calculation basis (Actual/360, 30/360, etc.)?",
  "What are the interest payment dates?",
  "What is the interest commencement date?",
  "What is the maturity date?",
  "Is the bond bullet or amortizing?",
  "Is there a call schedule?",
  "Is there a make-whole call provision?",
  "What is the make-whole premium formula?",
  "Is there an equity clawback provision?",
  "Are there any tax gross-up obligations?",
  "Is withholding tax risk disclosed and allocated correctly?",
  "What are the redemption mechanics (notice periods, record date)?",
  "Is there a sinking fund or mandatory redemption feature?",
  "Are there change-of-control redemption rights?",
  "Is there an asset sale redemption clause?",
  "Are there early redemption options for tax events?",
  "Is there a put option (e.g., delisting, breach, or rating trigger)?",
  // 3. Security & Structural Features
  "Are the bonds secured or unsecured?",
  "What assets are pledged as security?",
  "Is there a security trustee or collateral agent?",
  "Are perfection requirements under local law addressed?",
  "What is the ranking of the security (first lien, second lien, pari passu)?",
  "Are there intercreditor agreements?",
  "What is the waterfall of enforcement proceeds?",
  "Are there limitations on future secured debt (negative pledge)?",
  "Do the guarantees meet local corporate benefit and financial assistance rules?",
  "Is there a limitation on guarantees or exclusions (non-EU subsidiaries, etc.)?",
  // 4. Covenants & Restrictions
  "Is there a limitation on indebtedness covenant?",
  "What ratio tests apply (Fixed Charge Coverage, Total Leverage)?",
  "Is the covenant ratio maintenance or incurrence-based?",
  "Are definitions of 'Consolidated EBITDA' and 'Indebtedness' standard or adjusted?",
  "Are pro forma adjustments allowed in covenant calculations?",
  "Is there a limitation on restricted payments (dividends, share buybacks)?",
  "Is there an investment covenant restricting non-core acquisitions?",
  "Are asset sales governed by a reinvestment or redemption requirement?",
  "Are there limitations on transactions with affiliates?",
  "Are there limitations on liens?",
  "Is there a clause restricting mergers or consolidations?",
  "Is there a requirement to maintain listing or registration?",
  "Are there reporting covenants (quarterly/annual, IFRS or GAAP)?",
  "Are financial statements to be audited by a recognized auditor?",
  "Is there a requirement to deliver compliance certificates?",
  "Are there clauses related to insurance maintenance?",
  "Are there clauses related to tax compliance and residency?",
  "Are there limitations on the issuance of preferred stock?",
  "Are there restrictions on sale-leaseback transactions?",
  "Is there an obligation to provide notice of default to the trustee/investors?",
  // 5. Events of Default & Remedies
  "What constitutes an event of default?",
  "What are the applicable cure periods?",
  "Is there a payment default clause?",
  "Is there a breach of covenant default clause?",
  "Is there a cross-default clause?",
  "Is there a cross-acceleration clause?",
  "Is there an insolvency default trigger?",
  "Is there a judgment default trigger?",
  "Is there a change of control default trigger?",
  "Is there a material adverse change clause?",
  "Who has the right to accelerate the bonds?",
  "What voting thresholds apply for acceleration (25%, 50%, majority)?",
  "Are waivers and amendments allowed with bondholder consent?",
  "What is the quorum and voting mechanism for noteholder meetings?",
  "Are minority bondholders adequately protected?",
  "Are trustee enforcement powers clearly defined?",
  "Are governing law and enforcement provisions consistent throughout?",
  "Are currency and payment provisions clearly defined?",
  "Are force majeure or illegality provisions included?",
  "Are subordination terms (if any) clearly disclosed?",
  // 6. Disclosure, Risk & Compliance
  "Is the use of proceeds clearly described?",
  "Are risk factors comprehensive and specific to the issuer?",
  "Are forward-looking statements properly disclaimed?",
  "Is there a section on capitalisation and indebtedness?",
  "Are material litigation and contingent liabilities disclosed?",
  "Are related party transactions adequately disclosed?",
  "Are recent developments up to date (within 6 months)?",
  "Is there a summary of key financial ratios and trends?",
  "Are the offering restrictions (EEA, UK, US, CH, etc.) clearly stated?",
  "Are the MiFID II / PRIIPs / MAR disclosures complete and compliant?",
];

export const BOND_QUESTION_SECTIONS = [
  { title: "Legal Structure & Issuance Framework", start: 0, end: 20 },
  { title: "Key Economic Terms", start: 20, end: 40 },
  { title: "Security & Structural Features", start: 40, end: 50 },
  { title: "Covenants & Restrictions", start: 50, end: 70 },
  { title: "Events of Default & Remedies", start: 70, end: 90 },
  { title: "Disclosure, Risk & Compliance", start: 90, end: 100 },
];
